import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/kinetic-energy-calculator',
  component: () => import('../../routes/KineticEnergyCalculator.svelte'),
  card: {
    id: 'kinetic-energy-calculator',
    title: 'Kinetic Energy Calculator',
    description: 'Calculate kinetic energy, mass, or velocity using the KE = ½mv² formula. Enter any two values to find the third.',
    icon: 'speed',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/kinetic-energy-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Kinetic Energy Calculator – Calculate KE, Mass & Velocity',
    description:
      'Free kinetic energy calculator to find energy, mass, or velocity using the KE = ½mv² formula. Works for any two known values. Includes real-world examples.',
  },
};

export default meta;
